/**
 * Component: MerchantPointsTable
 * Table placeholder for points per merchant.
 */

import { CoinsIcon, ExternalIcon } from "@/assets/svg";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "@/components/ui/table/table";
import type { MerchantPointData } from "../../../../domain/model/DashboardModel";

export interface MerchantPointsTableProps {
  data: MerchantPointData[];
}

export const MerchantPointsTable = ({ data }: MerchantPointsTableProps): React.JSX.Element => {
  if (data.length === 0) {
    return (
      <div className="bg-white border border-[#e4e6eb] rounded-lg p-4 flex flex-col">
        <div className="flex justify-between items-center mb-3">
          <h3 className="m-0 text-slate-900 font-bold text-base leading-6">Redeemed Point per Merchant</h3>
        </div>
        <div className="flex items-center justify-center h-[200px] text-gray-500">
          No merchant data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-[#e4e6eb] rounded-lg p-4 flex flex-col">
      <div className="flex justify-between items-center mb-3">
        <h3 className="m-0 text-slate-900 font-bold text-base leading-6">Redeemed Point per Merchant</h3>
        <button
          className="bg-transparent border-none p-0 cursor-pointer flex items-center justify-center hover:opacity-80 focus:outline-none active:opacity-60"
          aria-label="Open external link"
        >
          <ExternalIcon />
        </button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Merchant</TableHead>
            <TableHead className="text-right">Redeemed Point</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.merchantId}>
              <TableCell className="!p-1">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg overflow-hidden shrink-0">
                    <img
                      src={row.logoUrl}
                      alt={row.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="font-normal">{row.name}</span>
                </div>
              </TableCell>
              <TableCell className="text-right !p-1">
                <div className="flex items-center justify-end gap-2 font-bold">
                  <span>{row.points.toLocaleString("id-ID")}</span>
                  <CoinsIcon />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
